// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3SZFz","errorLogs":"EditorFooter_errorLogs__2WWGj"};